import { Injectable } from '@angular/core';
import { AppConfig } from './../../../app.config';
import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';

/**
 * Definição da classe.
 */
@Injectable()
export class RelatorioService {


    /**
     * URL da api.
     */
    private baseUrl:string = AppConfig.API_URL + '/relatorio';

    /**
     * Construtor.
     */
    constructor(private http: HttpClient) { }

    /**
     * Salvar um relatorio.
     */
    public saveRelatorio( relatorio ):any {
        return this.http.post(this.baseUrl, relatorio);
    }

    /**
     * Atualizar um relatorio.
     */
    public updateRelatorio( relatorio ):any {
        return this.http.put(this.baseUrl, relatorio);
    }

    /**
     * Salvar arquivos.
     */
    public saveArquivos( form ):any {
        return this.http.post(this.baseUrl, form);
    }

    /**
     * Busca todos os relatorios.
     */
    public findAll( ):any {
        return this.http.get(this.baseUrl);
    }

    /**
     * Busca relatorio por id.
     */
    public searchById( id ):any {
        return this.http.get(this.baseUrl+'/'+id);
    }

    /**
     * Busca relatorio por id.
     */
    public delete( id ):any {
        return this.http.delete(this.baseUrl+'/'+id);
    }

}
